<section class="mt-2">
    <div class="action-btn px-4">
        <button class="mr-10" (click)="showModal = true;modalMessage = 'Are you sure to revert the changes?'" nz-button
            nzType="default">Reset</button>
        <button class="mr-10" nz-button nzType="primary" (click)="saveAttributes()">OK</button>
        @if(openUpdateWindow){
        <button nz-button nzType="primary" (click)="saveAttributes(true)">Save and Close</button>
        }
    </div>
    <div class="link-options-tab d-flex justify-content-between">
        <div>
            <span class="px-2">Bullet Style </span> <nz-switch [(ngModel)]="attrSwitch"
                (ngModelChange)="openModal($event)"></nz-switch> <span class="px-2">Attribute Style</span>
        </div>
        <div>
            <span class="px-2">Collapse All: </span> <nz-switch (click)="collapseAll()"></nz-switch>
        </div>
    </div>

    <form [formGroup]="addEditCatalogForm">
        <div class="add-catalog-form p-4 row">
            @if(verifyAttrValues() && inValidAttrValForm){
            <div class="d-flex text-end">
                <span class="error-span"> {{attrSwitch ? 'Product Attributes Values are required' : 'Product Bullets
                    Values are required'}} </span>
            </div>
            }
            <div>
                @if(addEditCatalogForm.controls['attributeArray']) {
                <ng-container formArrayName="attributeArray">

                    <div class="col-md-12 attriubte-block" *ngFor="let descForm of attrArrayControls; let i = index"
                        [formGroupName]="i">

                        <nz-collapse class="attribute-panel" #panelRef class="mb-3" style="background-color: #ffff;"
                            nzAccordion>
                            <nz-collapse-panel #panelRef [nzExtra]="customExpandIcon" nzShowArrow="false"
                                [nzActive]="descForm.controls['collapse'].value" [nzHeader]="header">

                                <div class="d-flex align-items-center row">
                                    @if(attrSwitchConfirmed) {
                                    <ng-container>
                                        <div class="mb-1 px-1 col-md-10 position-relative">
                                            <label class="form-label"> Attribute Values
                                            </label>
                                            <!-- <input type="text" class="form-control" placeholder=""
                                                formControlName="attributeValue"
                                                (keydown.enter)="$event.preventDefault();$event.stopPropagation();addItemtoAttrValArray('addNew',i,descForm)"> -->

                                            <app-rich-text-field [placeholder]="'Enter Values'"
                                                formControlName="attributeValue" (paste)="onPaste($event)"
                                                [toolbar]="toolbar"></app-rich-text-field>

                                        </div>
                                        <div class="col-md-1 px-1">
                                            <label class="form-label">
                                            </label>
                                            <button (click)="addItemtoAttrValArray('addNew',i,descForm)"
                                                class="d-flex align-items-center justify-content-center" nz-button
                                                nzType="default">
                                                <span nz-icon [nzType]="'plus'"></span>Value
                                            </button>

                                        </div>
                                        @if(attrArrayValuesControls(i).value && attrArrayValuesControls(i).value.length
                                        > 0 ){
                                        <div class="d-flex flex-wrap mt-4" cdkDropList
                                            [cdkDropListData]="attrArrayValuesControls(i).controls"
                                            cdkDropListOrientation="mixed"
                                            (cdkDropListDropped)="drop($event, attrArrayValuesControls(i).controls,i)">
                                            @for(tag of attrArrayValuesControls(i).controls; let j = $index; track
                                            tag){
                                            <nz-tag style="cursor: move;" cdkDrag class="m-1 text-wrap"
                                                (nzOnClose)="deleteAttrVal(tag,i,j)" [nzMode]="'closeable'">
                                               <span class="d-inline-block align-middle rich-text-tag" [innerHTML]="tag?.value.attributeValue"></span>
                                            </nz-tag>
                                            }
                                        </div>
                                        }

                                    </ng-container>
                                    }
                                    @else {
                                    <ng-container formArrayName="attrValArray">
                                        @if(attrValArrayControls(i)){
                                        <div cdkDropList [cdkDropListData]="attrValArray(i).controls"
                                            cdkDropListOrientation="vertical"
                                            (cdkDropListDropped)="drop($event, attrValArray(i).controls,i)">
                                            <div *ngFor="let tag of attrValArray(i).controls; let y = index;"
                                                [formGroupName]="y" class="mb-1 px-1 col-md-12">
                                                <div class="input-group mb-2" cdkDrag>
                                                    <span style="cursor:move ;" class="holder-icon" cdkDragHandle
                                                        nz-icon [nzType]="'holder'"></span>
                                                    <!-- <input type="text" formControlName="attributeValue" maxlength="100"
                                                        class="form-control" placeholder="Enter Values"> -->

                                                    <app-rich-text-field class="col-md-11" (paste)="onPaste($event)"
                                                        [placeholder]="'Enter Values'" formControlName="attributeValue"
                                                        [maxLength]="100" [toolbar]="toolbar"></app-rich-text-field>

                                                    <span class="close-icon" class="px-1" nz-icon
                                                        (click)="clearBulletValue(attrValArray(i),y)"
                                                        nzType="close-circle"></span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-1 px-1 mt-2">
                                            <button [disabled]="attrArrayValControls.length == 10" type="button"
                                                (click)="addItemtoAttrValArray('addNew',i,descForm)"
                                                class="d-flex align-items-center justify-content-center" nz-button
                                                nzType="default">
                                                <span nz-icon [nzType]="'plus'"></span>Value
                                            </button>
                                        </div>
                                        }
                                    </ng-container>
                                    }

                                    <ng-template #customExpandIcon>
                                        <div class="extra-icon-block">
                                            <img class="expand-icon" (click)="handleCollapse(i)"
                                                [src]="descForm.controls['collapse'].value ? 'arrow_up.png' : 'arrow_down.png'">
                                        </div>
                                    </ng-template>
                                    <ng-template #holderIcon>
                                        <i class="holder-icon px-3" cdkDragHandle nz-icon nzType='holder'></i>
                                    </ng-template>
                                    <ng-template #header>
                                        @if(attrSwitchConfirmed){
                                        <span class="mt-2"> {{descForm.get('attributeName')?.value}} </span>
                                        }
                                        @else{
                                        <span class="mt-2"> Bullets</span>
                                        }
                                    </ng-template>
                                </div>
                            </nz-collapse-panel>
                        </nz-collapse>
                    </div>
                </ng-container>
                }
            </div>
        </div>
    </form>
</section>
<app-confirm-popup *ngIf="showModal" [title]="'Confirmation'" [message]="modalMessage" confirmText="Confirm"
    [triggerModal]="showModal" [cancelText]="'Cancel'" (confirm)="confirmModalAction()"
    (cancel)="cancelModalAction()"></app-confirm-popup>